import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { IFilterGroup } from '../../shared/report/report-data.service';
import { IObject } from '../../../type_definitions/datatypes';
import { UntypedFormGroup } from '@angular/forms';
import { Dictionary } from '../../../type_definitions/vendor';
import { IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';

@Component({
  selector: 'report-filters-collapsible',
  template: `
    <div class="col-sm-12">
      <div class="collapsible-filter-section" *ngFor="let list of groups; trackBy: trackByFunction">
        <collapsible-pane [title]="list.title" [collapsed]="list.collapsed" (onChange)="toggleSection(list, $event)" [partialRender]="true">
          <formly [form]="form" [fields]="fields[list.code]" [model]="model" class="report-filters" [noValidate]="true">
            <ng-container *ngTemplateOutlet="searchButtonTemplateRef"></ng-container>
          </formly>
        </collapsible-pane>
      </div>
    </div>
  `
})
export class ReportFiltersCollapsibleComponent {
  @Input() public groups: IFilterGroup[];
  @Input() public model: IObject;
  @Input() public fields: Dictionary<IExtraFieldConfigurationObject[]>;
  @Input() public form: UntypedFormGroup;
  @ContentChild('searchButton', { static: false }) public searchButtonTemplateRef: TemplateRef<HTMLButtonElement>;

  @Output() public onCollapsedChange:EventEmitter<IFilterGroup> = new EventEmitter();

  constructor() {
    /**/
  }

  public toggleSection(section: IFilterGroup, collapsed:boolean):void {
    section.collapsed = collapsed;
    this.onCollapsedChange.emit(section);
  }

  public trackByFunction = (index: number): number => {
    return index;
  };
}